// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
// 服务名
export default {
  getOperatorsTree(params){
    return http.requestPost(apiPre + service.member + '/member/operator/listForSelectTree', params)
  }
}



// WEBPACK FOOTER //
// ./src/module/operatingCenter/api/commonApi.js